// Studyo Today Backend
// Package studyo.today.schools.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/school.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_studyo_today_schools_v1_resources_access_right } from "./access_right_pb.js";
import { file_studyo_today_schools_v1_resources_school_sharing_mode } from "./school_sharing_mode_pb.js";

/**
 * Describes the file studyo/today/schools/v1/resources/school.proto.
 */
export const file_studyo_today_schools_v1_resources_school = /*@__PURE__*/
  fileDesc("Ci5zdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvc2Nob29sLnByb3RvEiFzdHVkeW8udG9kYXkuc2Nob29scy52MS5yZXNvdXJjZXMitwMKBlNjaG9vbBIKCgJpZBgBIAEoCRIwCgxjcmVhdGVkX3RpbWUYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEjAKDHVwZGF0ZWRfdGltZRgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASEgoKc3luY190b2tlbhgEIAEoAxIMCgRuYW1lGAUgASgJEhAKCHN1YnRpdGxlGAYgASgJEkUKDWFjY2Vzc19yaWdodHMYByADKAsyLi5zdHVkeW8udG9kYXkuc2Nob29scy52MS5yZXNvdXJjZXMuQWNjZXNzUmlnaHQSGgoSc2NoZWR1bGVfY3ljbGVfaWRzGAggAygJEhAKCHRpbWV6b25lGAkgASgJEkoKDHNoYXJpbmdfbW9kZRgKIAEoDjI0LnN0dWR5by50b2RheS5zY2hvb2xzLnYxLnJlc291cmNlcy5TY2hvb2xTaGFyaW5nTW9kZRIiChppZ25vcmVkX3NjaGVkdWxlX2N5Y2xlX2lkcxgLIAMoCRITCgtpc19hcmNoaXZlZBgMIAEoCBIPCgdpc19kZW1vGA0gASgIQimqAiZTdHVkeW8uVG9kYXkuU2Nob29scy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z", [file_google_protobuf_timestamp, file_studyo_today_schools_v1_resources_access_right, file_studyo_today_schools_v1_resources_school_sharing_mode]);

/**
 * Describes the message studyo.today.schools.v1.resources.School.
 * Use `create(SchoolSchema)` to create a new message.
 */
export const SchoolSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_resources_school, 0);

